/**
 * Home widget block renderers — each wraps a homepage/contact section and
 * forwards CMS block.data through to the component so admins can edit copy
 * directly from the block editor (registry.js schemas define the fields).
 *
 * Six of these blocks (Solutions Overview, Power Every Part, Products
 * Showcase, Home Features Grid, Get Started Now, Final CTA) are fully
 * editable: each component accepts a `data` prop and merges it over its
 * defaults + any legacy Site Settings override. The remaining widgets
 * (CTA banners, ContactForm) continue to read from Site Settings.
 */
import SolutionsOverview from "@/components/home/SolutionsOverview";
import PowerEveryPart from "@/components/home/PowerEveryPart";
import ProductsShowcase from "@/components/home/ProductsShowcase";
import FeaturesGrid from "@/components/home/FeaturesGrid";
import GetStartedNow from "@/components/home/GetStartedNow";
import FinalCTA from "@/components/home/FinalCTA";
import CTABanner from "@/components/home/CTABanner";
import ContactForm from "@/components/contact/ContactForm";

export function SolutionsOverviewBlock({ data }) {
  return <SolutionsOverview data={data} />;
}

export function PowerEveryPartBlock({ data }) {
  return <PowerEveryPart data={data} />;
}

export function ProductsShowcaseBlock({ data }) {
  return <ProductsShowcase data={data} />;
}

export function HomeFeaturesGridBlock({ data }) {
  return <FeaturesGrid data={data} />;
}

export function GetStartedNowBlock({ data }) {
  return <GetStartedNow data={data} />;
}

export function FinalCtaBlock({ data }) {
  return <FinalCTA data={data} />;
}

export function HomeCtaDarkBlock() {
  return <CTABanner variant="dark" />;
}

export function HomeCtaLightBlock() {
  return <CTABanner variant="light" />;
}

export function ContactFormBlock() {
  return <ContactForm />;
}
